import PropTypes from 'prop-types';

export const productType = PropTypes.object;
export const userType = PropTypes.object;
export const siteType = PropTypes.object;
